import {getItemForPost} from "../../post/getItemForPost.js";
import {addImpression} from "../../utils/addImpression.js";
import {decorateDateString} from "../../utils/decorateDateString.js";

export function populateItemBox(entry, container, timelineElement) {
    if (entry.item_no !== "") {
        container.addClass("item");
        if (container[0]?.classList.contains("already-loaded")) {
            return;
        } else {
            container?.[0]?.classList.add("already-loaded");
        }
        var clonedBox = $(".item_box_prototype").clone().appendTo(container);
        clonedBox.removeClass("item_box_prototype");
        clonedBox.removeClass("hidden");
        clonedBox.addClass("item_box");
        clonedBox.find(".headline").prepend(entry.description);
        clonedBox.find("input[type=\"hidden\"][name=\"post_id\"]").val(entry.id);
        clonedBox.find(".prost_count").text(entry.sum_prosts);
        clonedBox.find(".comment_count").text(entry.sum_comments);
        clonedBox.find(".js-post-date").text(decorateDateString(timelineElement.post_date));
        clonedBox.find(".js-author-comment").html(entry.content);
        getItemForPost(entry, timelineElement);
        if (timelineElement !== undefined) {
            addImpression(timelineElement.id);
        }
    } else {
        container.remove();
    }
}